/** @deprecated Import from `@shared/phone` — re-export for negocio settings. */
export {
  digitsOnlyPhone,
  formatArPhoneDisplay,
  isCompleteArPhone,
  isCompleteArWhatsApp,
  nationalPartFromStored,
  normalizeArPhone,
  normalizeArWhatsApp,
  normalizeOptionalArPhone,
  normalizeStoreContactFields,
  telHref,
  whatsAppDigits,
  whatsAppHref,
} from '@shared/phone';
